var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02 21.322 13.648 11.05 3.02.778A1.517 1.517 0 1 0 .916 2.963l8.372 8.087-8.372 8.096a1.517 1.517 0 0 0 2.104 2.185v-.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextCarousel);
export default __webpack_public_path__ + "static/media/nextCarousel.e298335df74a11323d028630c9be7025.svg";
export { ForwardRef as ReactComponent };